// extracted by mini-css-extract-plugin
module.exports = {"snippetWrapper":"installDocs_snippetWrapper_Tkt64EQ","codeCopy":"installDocs_codeCopy_1Mpf3Np","snippet":"installDocs_snippet_1p45dgv"};